import { SelectedFilterState, FrequencyBand } from "../types";

export const normalColor = "#4caf50";
export const subClinicoColor = "#ff9800";
export const clinicoColor = "#f44336";

export const getValueColor = (value: number) => {
    if (value < 0.5) return normalColor;
    if (value < 1.5) return subClinicoColor;
    return clinicoColor;
};

export const getImprovementColor = (improvement: number) => {
    if (improvement > 0) return "#4caf50";
    if (improvement < 0) return "#f44336";
    return "#9e9e9e";
};

export const BANDS_IDS = {
    delta: 6,
    theta: 7,
    alpha: 8,
    beta: 11,
    highBeta: 15,
    alpha1: 9,
    alpha2: 10,
    beta1: 12,
    beta2: 13,
    beta3: 14,
    gamma: 16,
    highGamma: 17,
    gamma1: 18,
    gamma2: 19,
};

export const sortBands = <T>(bands: Record<string, T>, bandData?: Array<FrequencyBand>) => {
    const sortedEntries = Object.entries(bands).sort(([a], [b]) => {
        if (!bandData) {
            return 0; // If no band data provided, maintain original order
        }
        const bandA = bandData.find(band => band.name === a);
        const bandB = bandData.find(band => band.name === b);
        const orderA = bandA ? bandA.order : 999;
        const orderB = bandB ? bandB.order : 999;
        return orderA - orderB;
    });
    return sortedEntries;
};

export const isInvalidBandSelection = (tempFilter: SelectedFilterState) => {
    const selectedBandIds = tempFilter.band.map((id) => Number(id));
    const invalidCombinations = [
        [BANDS_IDS.beta, BANDS_IDS.beta1],
        [BANDS_IDS.beta, BANDS_IDS.beta2],
        [BANDS_IDS.beta, BANDS_IDS.beta3],
        [BANDS_IDS.alpha, BANDS_IDS.alpha1],
        [BANDS_IDS.alpha, BANDS_IDS.alpha2],
        [BANDS_IDS.gamma, BANDS_IDS.gamma1],
        [BANDS_IDS.gamma, BANDS_IDS.gamma2],
    ];

    for (const [parent, child] of invalidCombinations) {
        if (selectedBandIds.includes(parent) && selectedBandIds.includes(child)) {
            return "Não é possível filtrar desta forma, tem bandas duplicadas no seu filtro";
        }
    }

    if (tempFilter.band.length === 0 && tempFilter.individual.length === 0) {
        return "Tem que selecionar pelo menos uma banda ou uma frequência individual";
    }

    return false;
};

export const eegDataFields = [
    "*",
    "metric.*",
    "single_electrode_location.*",
    "frequency_band.*",
    "frequency_individual_value.*",
    "pair_electrode_location.*",
    "pair_electrode_location.electrode_location_one.*",
    "pair_electrode_location.electrode_location_two.*",
    "pair_frequency_bands.*",
    "pair_frequency_bands.frequency_band_one.*",
    "pair_frequency_bands.frequency_band_two.*",
].join(",");
